export default "__VITE_ASSET__CbTukewR__"